// extracted by mini-css-extract-plugin
export default {"wrapper":"Press_wrapper__-RUuV","container":"Press_container__5eYiU","mainWrapper":"Press_mainWrapper__iuDzz"};